<template>
  <div class="add">
    <button title="Add Ship Level" class="btn btn-success" @click="addChild"><i class="fa fa-cubes"></i></button>
  </div>
</template>

<script>

export default {
  name: "ShippingLvlAddButton",
  props: ['component', 'level'],
  methods: {
    addChild() {
      if(!Array.isArray(this.component.components)) this.component.components = [];
      this.$modal.show("shipping-lvl-modal", { parent: this.component, level: this.level });
    }
  }
}
</script>


// WEBPACK FOOTER //
// ShippingLvlAddButton.vue?7d93a9ef